
import Layout from '../../components/layout'
import TaskAltIcon from '@mui/icons-material/TaskAlt';

import ServiceBox from "../../components/servicebox";
import ServiceCard from "../../components/servicecard";



import { useState, useEffect } from 'react'

export default function OfferPage() {

  const services = [
    { title: "Strategi & Arkitektur", description: "Så himla bra när allt blir rätt" },
    { title: "Desing", description: "Du vet, vi kan" },
    { title: "Felsökning", description: "hundra tusen smarta saker om det här också" },
    { title: "Utbildning", description: "Vi lär dig det ena och det andra" },
    { title: "Drift", description: "Koll på läget, i alla lägen" }
  ]

  const delivery = [
    { title: "Rådgivning", description: "Expertrådgivning kring arkitektur design eller strategifrågor." },
    { title: "Bemanning", description: "Vi stärker upp med rätt resurs för uppdraget, oavsett om det är tekniskt avancerat eller drift." },
    { title: "Turn-key", description: "Vi driver hela processen från kravställning till färdig leverans och sätter ihop ett optimerat team för uppgiften." },
    { title: "As a Service", description: "Oavsett vilken typ av hjälp ni vill ha så finns det att köpa som tjänst!" }
  ]

  return (

    <Layout >
      <div id="offer" className="section">
        <div className="flex flex-col sm:px-8 justify-center gap-2">
          <h1 className="text-4xl text-center">Ace:a det <span className="text-sky-500">med</span> oss</h1>

          <p className="py-2 text-lg">
            Vi hjälper er att planera, implementera och optimera moderna nätverk.
          </p>
          <p className="py-2 text-lg">
            Behöver ni förstärka ert team med rätt kompetens? Söker ni expertis för att lösa tekniska eller organisatoriska utmaningar? Eller kanske en helhetslösning där vi tar hand om allt? Vi erbjuder flexibla samarbeten på det sätt som passar er bäst.
          </p>

          <div className="flex flex-col gap-4">
            <p className="text-xl text-center">Hur vill ni samararbeta med oss?</p>
            <div className="flex justify-center items-center gap-4">
              <div className="flex flex-col sm:flex-row w-4/5 sm:w-full gap-4 justify-center">
                {delivery.map((item, index) => (
                  <ServiceCard
                    title={item.title}
                    description={item.description}
                    key={index}
                  />
                )
                )}
              </div>
            </div>
          </div>

        </div>
      </div>
    </Layout>
  )
}
